import { isDevelopment } from "utils/helpers/IsDevelopment";
import { Brand } from "utils/models/CommonTypes";

const brandMap: Record<string, Brand> = {
  avmed: Brand.AVMED,
  sentarahealthplans: Brand.SENTARA,
};

const getBrandFromHost = (
  hostname: string = window.location.hostname
): Brand | undefined => {
  if (!hostname) {
    console.error("Hostname is empty or undefined.");
    return;
  }

  const subdomainsToRemove = ["dev", "qa", "uat", "test"];
  const parts = hostname.split(".");

  if (parts.length < 3) {
    console.error("Hostname format is invalid or unexpected.");
    return;
  }

  if (subdomainsToRemove.includes(parts[0])) {
    parts.shift();
  }

  if (parts.length < 2) {
    console.error("Unable to determine the brand from the hostname.");
    return;
  }

  const brandName = parts[parts.length - 2];
  return brandMap[brandName];
};

export const getBrand = (): Brand | undefined => {
  const envBrand = process.env.REACT_APP_BRAND?.toUpperCase();

  if (isDevelopment()) {
    if (envBrand && Object.values(Brand).includes(envBrand as Brand)) {
      const brand = brandMap[envBrand];
      if (brand) {
        return brand;
      }
    }
    console.warn(`Brand ${envBrand} is not recognized. Defaulting to SENTARA.`);
    return Brand.SENTARA; // Default brand for development
  }
  const brandFromHost = getBrandFromHost();

  return brandFromHost;
};
